export default __webpack_public_path__ + "static/landing-page-01132f542f7a3eeda30d5a5c844a2771.png";